var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as yup from 'yup';
import config from 'core/config';
import capency from 'helpers/capency';
var codeRegexp = /^[\w]{2,}$/;
var phoneRegexp = /^[0-9- _()]+$/;
var expirationRegexp = /^((0[1-9])|(1[0-2]))\/[0-9]{2}$/;
var nameRegexp = /^[A-z\u00C0-\u00ff\s'\-()]*$/;
var latinRegexp = /^[0-9A-z\u00C0-\u00ff\s'.,-/#!$%^&*;:{}=\-_`~()]*$/;
var passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,})/;
var _a = config.errors, errors = _a === void 0 ? {} : _a;
yup.setLocale({
    mixed: {
        default: errors.invalid,
        notType: errors.invalid,
        required: errors.required
    },
    number: {
        min: errors.invalid,
        max: errors.invalid
    },
    string: {
        email: errors.email,
        min: errors.invalid,
        max: errors.invalid,
        matches: errors.invalid
    }
});
var validators = {
    address: yup.string().matches(latinRegexp, errors.latin),
    name: yup.string().matches(nameRegexp, errors.latin),
    email: yup.string().email(),
    capencyMail: yup.string().test(function (value, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var check, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (ctx.options.context.ignoreCapency)
                        return [2 /*return*/, true];
                    if (!value)
                        return [2 /*return*/, true];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, capency.checkMail(value)];
                case 2:
                    check = _a.sent();
                    if (check.error)
                        return [2 /*return*/, ctx.createError({ message: check.message })];
                    else
                        return [2 /*return*/, true];
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, true];
                case 4: return [2 /*return*/];
            }
        });
    }); }),
    expirationcard: yup.string().matches(expirationRegexp),
    code: yup.string().matches(codeRegexp),
    password: yup.string().matches(passwordRegexp, errors.password),
    // day: yup.lazy((v) => (v === '' ? yup.string() : )),
    // month: yup.lazy((v) => (v === '' ? yup.string() : yup.number().min(1).max(12))),
    // year: yup.lazy((v) => (v === '' ? yup.string() : yup.number().min(1900).max(2030))),
    city: yup.string().matches(latinRegexp, errors.latin),
    street: yup.string().matches(latinRegexp, errors.latin),
    string: yup.string(),
    phonecode: yup.string(),
    phone: yup.string().min(5).matches(phoneRegexp),
    capencyPhone: yup.string().test(function (value, ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var parentEntries, country, check, e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (ctx.options.context.ignoreCapency)
                        return [2 /*return*/, true];
                    if (!value)
                        return [2 /*return*/, true];
                    parentEntries = Object.entries(ctx.parent);
                    country = (_a = parentEntries.find(function (entry) { return entry[0].includes('phone_code'); })) === null || _a === void 0 ? void 0 : _a[1];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, capency.checkPhone(value, country)];
                case 2:
                    check = _b.sent();
                    if (check.error)
                        return [2 /*return*/, ctx.createError({ message: check.message })];
                    return [2 /*return*/, true];
                case 3:
                    e_2 = _b.sent();
                    return [2 /*return*/, true];
                case 4: return [2 /*return*/];
            }
        });
    }); }),
    required: function (v) { return (v || yup.string()).required(); },
    bool: (function () {
        var bool = yup.bool();
        bool.required = function () { return bool.oneOf([true]); };
        return bool;
    })()
};
validators.passwordConfirm = validators.password.oneOf([yup.ref('password'), yup.ref('new-password'), null], errors.confirmPassword);
validators.day = yup.mixed().when(['$month', '$year'], {
    is: function (month, year) { return (!!month || !!year); },
    then: function () { return yup.number().min(1).max(31); }
});
validators.month = yup.mixed().when(['$day', '$year'], {
    is: function (day, year) { return (!!day || !!year); },
    then: function () { return yup.number().min(1).max(12); }
});
validators.year = yup.mixed().when(['$month', '$day'], {
    is: function (month, day) { return (!!month || !!day); },
    then: function () { return yup.number().min(1900).max(2030); }
});
export default validators;
